import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

function ErrorPopup({ show, handleClose, title, message }) {
    const { t } = useTranslation('messages');
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="border-bottom-0 pb-0">
                <Modal.Title className="d-flex align-items-center gap-2 text-danger">
                    <ExclamationTriangleFill size={20} />
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-2 pb-4">{message}</Modal.Body>
            <Modal.Footer className="border-top-0 pt-0">
                <Button variant="outline-secondary" size="sm" onClick={handleClose}>
                    {t('error.popup.close_button')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ErrorPopup;